import React from "react";
import { Col, Row, Table } from "react-bootstrap";

const DataTable = ({ tableHeadings, tableData }: any) => {
  return (
    <Row className="mb-5">
      <Col xs={12}>
        <div style={{ overflowX: "auto" }}>
          <Table striped>
            <thead>
              <tr>
                {tableHeadings?.map((heading: any) => (
                  <th key={heading?.key}>{heading?.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData?.map((row: any, rowIndex: number) => (
                <tr key={rowIndex}>
                  {tableHeadings?.map((heading: any) => (
                    <td className="text-capitalize" key={heading?.key}>
                      {row[heading?.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Col>
    </Row>
  );
};

export default DataTable;
